var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShareIOs = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5116 3.76744L8.51162 1.76745V10.4186H7.58139V1.76744L5.58139 3.76744L4.93022 3.11628L8.0465 0L11.1628 3.11628L10.5116 3.76744ZM3.39535 16H12.6977C13.4884 16 14.093 15.3953 14.093 14.6047V6.23256C14.093 5.44187 13.4884 4.83722 12.6977 4.83722H9.44186V5.76745H12.6977C12.9767 5.76745 13.1628 5.9535 13.1628 6.23256V14.6047C13.1628 14.8837 12.9767 15.0698 12.6977 15.0698H3.39535C3.11628 15.0698 2.93023 14.8837 2.93023 14.6047V6.23256C2.93023 5.9535 3.11628 5.76745 3.39535 5.76745H6.65116V4.83722H3.39535C2.60465 4.83722 2 5.44187 2 6.23256V14.6047C2 15.3953 2.60465 16 3.39535 16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareIOs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Share-iOS.7f514a4b.svg";
export { ForwardRef as ReactComponent };